<template>
  <div>
    <b-card no-body>
      <div slot="header" class="title_head">
        Category List
        <span v-if="cat_rights === true"
          ><button
            type="button"
            style="width: 115px;"
            class="btn btn-sm btn-primary label_bttn"
            variant="secondary"
            @click="openmodel"
          >
            <i class="fa fa-plus"></i> Add Category
          </button></span
        >
      </div>
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <div class="row">
            <div class="col-sm-12">
              <div v-if="hasErrors.message1" class="alert alert-success">
                <center>{{ errorMessage.message1 }}</center>
              </div>
            </div>
          </div>
          <div class="table-responsive-sm">
            <vue-good-table
              :columns="columns"
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              styleClass="vgt-table striped bordered table-sm condensed"
              :rows="rows"
              :paginationOptions="{ enabled: true, perPage: 5 }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'action'">
                  <span v-if="cat_rights === true">
                    <span v-if="props.row.company_id !== 'I2OCGLB'">
                      <i
                        class="fa fa-edit"
                        @click.prevent="editpro(props.row)"
                      ></i>
                      <i
                        class="fa fa-trash"
                        @click.prevent="deletecategory(props.row)"
                      ></i>
                    </span>
                    <span v-else>
                      <span v-if="is_admin === true">
                        <i
                          class="fa fa-edit"
                          @click.prevent="editpro(props.row)"
                        ></i>
                        <i
                          class="fa fa-trash"
                          @click.prevent="deletecategory(props.row)"
                        ></i>
                      </span>
                      <span v-else>
                        <i
                          class="fa fa-edit"
                          style="color: grey !important;"
                        ></i>
                        <i
                          class="fa fa-trash"
                          style="color: grey !important;"
                        ></i>
                      </span>
                    </span>
                  </span>
                  <span v-else>
                    <i class="fa fa-edit" style="color: grey !important;"></i>
                    <i class="fa fa-trash" style="color: grey !important;"></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <div slot="emptystate" style="text-align: center;" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
              </div>
            </vue-good-table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body>
      <div slot="header" class="title_head">
        Sub Category
        <p v-show="hide">{{ cat_view }}</p>
        <span v-if="cat_rights === true"
          ><button
            type="button"
            class="btn btn-sm btn-primary label_bttn"
            variant="secondary"
            @click="openmodel1"
          >
            <i class="fa fa-plus"></i> Add Sub Category
          </button></span
        >
      </div>
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <div class="row">
            <div class="col-sm-12">
              <div v-if="hasErrors.message" class="alert alert-success">
                <center>{{ errorMessage.message }}</center>
              </div>
            </div>
          </div>
          <vue-snotify></vue-snotify>
          <div class="table-responsive-sm">
            <vue-good-table
              :columns="columns1"
              styleClass="vgt-table striped bordered table-sm condensed"
              :rows="rows1"
              mode="remote"
              ref="my-table1"
              @on-page-change="onPageChange1"
              @on-sort-change="onSortChange1"
              @on-column-filter="onColumnFilter1"
              @on-per-page-change="onPerPageChange1"
              :totalRows="totalRecords1"
              :paginationOptions="{ enabled: true, perPage: 5 }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action1'">
                  <span v-if="cat_rights === true">
                    <span v-if="props.row.company_id !== 'I2OCGLB'">
                      <i
                        class="fa fa-edit"
                        @click.prevent="editpro1(props.row)"
                      ></i>
                      <i
                        class="fa fa-trash"
                        @click.prevent="deletesubcate(props.row)"
                      ></i>
                    </span>
                    <span v-else>
                      <span v-if="is_admin === true">
                        <i
                          class="fa fa-edit"
                          @click.prevent="editpro1(props.row)"
                        ></i>
                        <i
                          class="fa fa-trash"
                          @click.prevent="deletesubcate(props.row)"
                        ></i>
                      </span>
                      <span v-else>
                        <i
                          class="fa fa-edit"
                          @click.prevent="viewpro1(props.row)"
                          style="color: lightblue !important;"
                        ></i>
                        <i
                          class="fa fa-trash"
                          style="color: grey !important;"
                        ></i>
                      </span>
                    </span>
                  </span>
                  <span v-else>
                    <i class="fa fa-edit" style="color: grey !important;"></i>
                    <i class="fa fa-trash" style="color: grey !important;"></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <div slot="emptystate" style="text-align: center;" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
              </div>
            </vue-good-table>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-modal
      title="Add Sub Category"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="lg"
      class="modal-info"
      v-model="largeModal"
      @ok="largeModal = false"
    >
      <b-row>
        <b-col sm="12">
          <b-form-group>
            <label for="name">Category <span class="star">*</span></label>
            <model-list-select
              :list="categoryopt"
              option-value="category_name"
              option-text="category_name"
              v-model="Productvalue"
              :class="{ 'is-invalid': hasErrors.categoryopt }"
              placeholder="Select Category"
            ></model-list-select>
            <small class="form-text text-muted" v-if="hasErrors.categoryopt"
              ><strong style="color: red;">{{
                hasErrors.categoryopt
              }}</strong></small
            >
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label for="name"
              >Sub Category Name <span class="star">*</span></label
            >
            <b-form-input
              ref="txtsubcategoryname"
              type="text"
              @blur.native="chkExist('subcat')"
              v-model="subcate.name"
              :class="{ 'is-invalid': hasErrors.subcate }"
              placeholder="Enter Sub Category"
            ></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.subcate"
              ><strong style="color: red;">{{
                hasErrors.subcate
              }}</strong></small
            >
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <label for="name"
              >Sub Category Description <span class="star">*</span></label
            >
            <b-form-input
              type="text"
              v-model="subcate.description"
              :class="{ 'is-invalid': hasErrors.subcate1 }"
              placeholder="Description"
            >
            </b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.subcate1"
              ><strong style="color: red;">{{
                hasErrors.subcate1
              }}</strong></small
            >
          </b-form-group>
        </b-col>
      </b-row>
      <div class="card-footer modal_footer">
        <b-col sm="6">
          <b-button-group>
            <b-button
              type="submit"
              style="background-color: #1a94cb; color: #fff;"
              class="btn btn-sm btn-primary"
              @click.prevent="Save()"
              ><i class="fa fa-dot-circle-o"></i> Save</b-button
            >
          </b-button-group>
        </b-col>
      </div>
    </b-modal>
     <b-modal
            title="Plan Limit Reached"
            size="sm"
            class="modal-warning"
            ok-only 
            v-model="plan_modal"
          >
          <b-row>
            <b-col sm="2">
                <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                <b>You have hit the plan limit.</b>
                </b-row>
                <b-row>
                  You have reached the limit of adding Category. Please upgrade your plan to add more Categories.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>
    <b-modal
      title="Add Category"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="lg"
      v-model="largeModal1"
      class="modal-info"
      @ok="largeModal = false"
    >
      <b-row>
        <b-col sm="6">
          <b-form-group>
            <label for="name"
              >Category Name <span style="color: red;"> *</span></label
            >
            <b-form-input
              ref="txtcategoryname"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': hasErrors.category }"
              @blur.native="chkExist('cat')"
              v-model="category.name"
              placeholder="Enter  Category Name"
            ></b-form-input>
            <small class="form-text text-muted" v-if="hasErrors.category"
              ><strong style="color: red;">{{
                hasErrors.category
              }}</strong></small
            >
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <label for="name">
            Category Description <span style="color: red;"> *</span></label
          >
          <b-form-input
            type="text"
            v-model="category.description"
            :class="{ 'is-invalid': hasErrors.category1 }"
            placeholder="Enter Description"
          >
          </b-form-input>
          <small class="form-text text-muted" v-if="hasErrors.category1"
            ><strong style="color: red;">{{
              hasErrors.category1
            }}</strong></small
          >
        </b-col>
      </b-row>
      <div class="card-footer modal_footer">
        <b-row>
          <b-col sm="6">
            <b-button-group>
              <b-button
                type="submit"
                style="background: #1a94cb; color: #fff;"
                class="btn btn-sm btn-primary"
                @click.prevent="Submit()"
                ><i class="fa fa-dot-circle-o"></i> Save</b-button
              >
            </b-button-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      title="Edit Sub Category "
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="lg"
      class="modal-info"
      v-model="warningModal2"
      @ok="warningModal2 = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-form-group>
            <label for="name"
              >Related Category <span style="color: red;"> *</span></label
            >
            <model-list-select
              :list="categoryopt"
              option-value="category_name"
              option-text="category_name"
              v-model="Productvalue1"
              placeholder="Select Category"
              :class="{ 'is-invalid': hasErrors.categoryopt2 }"
            ></model-list-select>
            <small class="form-text text-muted" v-if="hasErrors.categoryopt2"
              ><strong style="color: red;">{{
                hasErrors.categoryopt2
              }}</strong></small
            >
          </b-form-group>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="name"
                  >Sub Category Name <span style="color: red;"> *</span></label
                >
                <b-form-input
                  type="text"
                  v-model="subcate.name3"
                  :class="{ 'is-invalid': hasErrors.subcate2 }"
                  placeholder="Enter  SubCategory "
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.subcate2"
                  ><strong style="color: red;">{{
                    hasErrors.subcate2
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name"
                  >Sub Category Description
                  <span style="color: red;"> *</span></label
                >
                <b-form-input
                  type="text"
                  v-model="subcate.description3"
                  :class="{ 'is-invalid': hasErrors.subcate3 }"
                  placeholder=" Sub Category Description"
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.subcate3"
                  ><strong style="color: red;">{{
                    hasErrors.subcate3
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <button
                type="submit"
                class="btn btn-sm btn-primary"
                @click.prevent="submodel1"
              >
                <i class="fa fa-dot-circle-o"></i> Save
              </button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-modal>

    <b-modal
      title="View Sub Category "
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="lg"
      class="modal-info"
      v-model="warningModal4"
      @ok="warningModal4 = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-form-group>
            <label for="name">Category</label>
            <model-list-select
              :list="categoryopt"
              option-value="category_name"
              option-text="category_name"
              v-model="Productvalue1"
              placeholder="Select Category"
            ></model-list-select>
          </b-form-group>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="name">Sub Category</label>
                <b-form-input
                  type="text"
                  disabled
                  v-model="subcate.name4"
                  placeholder="Enter Sub Category"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name">Sub Category Description</label>
                <b-form-input
                  type="text"
                  disabled
                  v-model="subcate.description4"
                  placeholder=" Sub Category Description"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-modal>

    <b-modal
      title="Edit Category"
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-info"
      v-model="warningModal"
      @ok="warningModal1 = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <b-card-body>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="name"
                  >Category Name <span class="star">*</span></label
                >
                <b-form-input
                  type="text"
                  v-model="category.name2"
                  :class="{ 'is-invalid': hasErrors.category2 }"
                  placeholder="Enter Category"
                ></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.category2"
                  ><strong style="color: red;">{{
                    hasErrors.category2
                  }}</strong></small
                >
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <label for="name"
                >Category Description <span class="star">*</span></label
              >
              <b-form-input
                type="text"
                v-model="category.description3"
                :class="{ 'is-invalid': hasErrors.category3 }"
                placeholder=" Category Description"
              ></b-form-input>
              <small class="form-text text-muted" v-if="hasErrors.category3"
                ><strong style="color: red;"
                  >{{ hasErrors.category3 }}
                </strong></small
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <button
                type="submit"
                class="btn btn-sm btn-primary"
                @click.prevent="submodel"
              >
                <i class="fa fa-dot-circle-o"></i> Save
              </button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
var idup = "";
import Spinner from "../../spinner.vue";
export default {
  name: "category",
  components: {
    Spinner,
  },

  data() {
    return {
      // pg_view:false,
      // pg_rights:false,
      plan_modal:false,
      shpfrst_time: false,
      is_admin: false,
      cfrst_time: false,
      sfrst_time: false,
      clf_time: false,
      hide: false,
      largeModal: false,
      largeModal1: false,
      warningModal: false,
      warningModal2: false,
      warningModal4: false,
      loading: false,
      columns: [
        {
          label: "Category",
          field: "category_name",
          width: "30% !important",
        },
        {
          label: "Description",
          field: "category_desc",
          width: "60% !important",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
        },
      ],
      rows: [],
      columns1: [
        {
          label: "Sub Category",
          field: "sub_category_name",
          width: "30% !important",
        },
        {
          label: "Description",
          field: "sub_category_desc",
          width: "60% !important",
        },
        {
          label: "Action",
          field: "action1",
          width: "10% !important",
        },
      ],
      rows1: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5,
      },
      Productvalue: null,
      Productvalue1: null,
      categoryopt: [],
      category: {
        name: "",
        description: "",
        name2: "",
        description3: "",
      },
      subcate: {
        name: "",
        description: "",
        name3: "",
        description3: "",
        name4: "",
        description4: "",
      },
      hasErrors: {
        message: false,
        message1: false,
        category: false,
        category1: false,
        subcate1: false,
        subcate: false,
        subcate2: false,
        subcate3: false,
        category2: false,
        category3: false,
        categoryopt: false,
        categoryopt2: false,
      },
      errorMessage: {
        message: null,
        message1: null,
        category: null,
      },
    };
  },
  computed: {
    cat_view: function () {
      if (this.$store.getters.get_cat_view === true) {
        this.shopuser("comp");
        this.getCategories("comp");
        this.subcatval("comp");
        this.categorylist("comp");
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    cat_rights: function () {
      return this.$store.getters.get_cat_rights;
    },
  },

  // created(){
  //   var roles = JSON.parse(localStorage.getItem('roles'))
  //   if(roles[19].page_name == 20){
  //     this.pg_view = roles[19].view
  //     this.pg_rights = roles[19].rights
  //     if(this.pg_view){
  //        this.shopuser();
  //         this.getCategories();
  //         this.subcatval();
  //         this.categorylist();
  //     }
  //   }
  // },

  methods: {
    chkExist(type) {
      if (type == "cat") {
        this.category.name = this.category.name.trim().replace("'", "''");
        var _this = this;
        if (this.category.name != "") {
          this.$http
            .get(
              "/api/categories/chk_exist?filter[where][category_name]=" +
                this.category.name
            )
            .then(function (response) {
              if (response.data.length > 0) {
                _this.category.name = "";
                _this.hasErrors.category = "Category name already exist";
                _this.$refs["txtcategoryname"].focus();
              } else {
                _this.hasErrors.category = false;
              }
            })
            .catch(function (error) {
              _this.hasErrors.category = false;
            });
        } else {
          _this.hasErrors.category = false;
        }
      } else {
        var _this = this;
        if (this.Productvalue !== null) {
          this.subcate.name = this.subcate.name.trim();
          if (this.subcate.name != "") {
            this.$http
              .get(
                "/api/subcategories/chk_exist?filter[where][sub_category_name]=" +
                  this.subcate.name +
                  "&filter[where][category_id]=" +
                  this.Productvalue.category_id
              )
              .then(function (response) {
                if (response.data.length > 0) {
                  _this.subcate.name = "";
                  _this.hasErrors.subcate = "Sub Category name already exist";
                  _this.$refs["txtsubcategoryname"].focus();
                } else {
                  _this.hasErrors.subcate = false;
                }
              })
              .catch(function (error) {
                _this.hasErrors.subcate = false;
              });
          } else {
            _this.hasErrors.subcate = false;
          }
        } else {
          this.hasErrors.categoryopt = "Please select category";
        }
      }
    },

    categorylist(val) {
      if (val === "comp") {
        if (this.clf_time === false) {
          this.clf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/categories")
        .then(function (response) {
          _this.categoryopt = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getCategories();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getCategories();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.getCategories();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.getCategories();
    },

    updateParams1(newProps) {
      this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
    },

    onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.subcatval();
    },

    onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.subcatval();
    },

    onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.subcatval();
    },

    onColumnFilter1(params) {
      this.updateParams1(params);
      this.subcatval();
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      // console.log('shopuser')
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    selectCategory(id) {
      var _this = this;
      this.$http
        .get("/api/categories/findOne?filter[where][category_id]=" + id)
        .then(function (response) {
          _this.Productvalue1 = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openmodel1() {
      this.largeModal = true;
      var _this = this;
      this.hasErrors.subcate = "";
      this.hasErrors.subcate1 = "";
      this.hasErrors.categoryopt = "";
      this.hasErrors.categoryopt2 = "";
      this.Productvalue = null;
      this.subcate.name = "";
      this.subcate.description = "";
    },
    
    openmodel() {
      var _this = this;
      this.loading = true;
      this.$http
        .get("/api/categories/chk_plan_count")
        .then(function (response) {
          // console.log(response)
          _this.loading = false;
          if ("message" in response.data) {
            if (response.data.message === false) {
              _this.largeModal1 = true;
              _this.plan_modal=false;
              _this.hasErrors.category = "";
              _this.hasErrors.categoryopt2 = "";
              _this.hasErrors.category1 = "";
              _this.category.name = "";
              _this.category.description = "";
            } else {
              _this.plan_modal = true
              // alert(response.data.message);
            }
          } else {
            console.log("something went wrong");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editpro(categorylistid) {
      this.warningModal = true;
      var _this = this;
      var id = categorylistid.id;
      this.hasErrors.category2 = "";
      this.hasErrors.category3 = "";
      this.category.name2 = categorylistid.category_name;
      this.category.description3 = categorylistid.category_desc;
      idup = categorylistid.category_id;
    },

    viewpro1(subcategorylistid) {
      this.warningModal4 = true;
      this.selectCategory(subcategorylistid.category_id);
      this.subcate.name4 = subcategorylistid.sub_category_name;
      this.subcate.description4 = subcategorylistid.sub_category_desc;
    },

    editpro1(subcategorylistid) {
      this.warningModal2 = true;
      this.hasErrors.subcate2 = "";
      this.hasErrors.subcate3 = "";
      this.hasErrors.categoryopt = "";
      this.hasErrors.categoryopt2 = "";
      var _this = this;
      this.selectCategory(subcategorylistid.category_id);
      this.subcate.name3 = subcategorylistid.sub_category_name;
      this.subcate.description3 = subcategorylistid.sub_category_desc;
      idup = subcategorylistid.sub_category_id;
    },

    deletecategory(cateid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        _this.loading = true;
        // var id =cateid.category_id;
        var id = cateid.id;
        this.$http
          .delete("/api/categories/" + id)
          .then(function (response) {
            _this.loading = false;
            _this.getCategories();
            _this.subcatval();
            _this.categorylist();
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
      }
    },

    deletesubcate(subcateid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        _this.loading = true;
        // var id =subcateid.sub_category_id;
        var id = subcateid.id;
        this.$http
          .delete("/api/subcategories/" + id)
          .then(function (response) {
            _this.loading = false;
            _this.subcatval();
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
      }
    },

    subcatval(val) {
      if (val === "comp") {
        if (this.sfrst_time === false) {
          this.sfrst_time = true;
        } else {
          return;
        }
      }
      // console.log("subcatval")
      var _this = this;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.$http
        .get(
          "/api/subcategories/showSubCategories?params=" +
            JSON.stringify(filteParam)
        )
        .then(function (response) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows1 = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    submodel1() {
      var _this = this;
      var submit_true = 0;
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      this.hasErrors.subcate2 = "";
      this.hasErrors.subcate3 = "";
      this.hasErrors.categoryopt = "";
      this.hasErrors.categoryopt2 = "";
      if (this.Productvalue1 == null) {
        _this.hasErrors.categoryopt2 = "Required";
        submit_true = 1;
      }

      if (this.subcate.name3 == "") {
        submit_true = 1;
        _this.hasErrors.subcate2 = "Required";
      } else if (
        this.subcate.name3.length > 100 ||
        this.subcate.name3.length < 2
      ) {
        submit_true = 1;
        _this.hasErrors.subcate2 = "Enter Maximum 100 and Minimum 2 characters";
      }

      if (this.subcate.description3 == "") {
        submit_true = 1;
        _this.hasErrors.subcate3 = "Required";
      }

      if (this.subcate.description3 != null) {
        if (this.subcate.description3.length > 100) {
          _this.hasErrors.subcate3 = "Maximum 100 characters allowed";
          submit_true = 1;
        }
      }

      if (submit_true == 0) {
        _this.loading = true;
        var subcate = {
          category_id: this.Productvalue1.category_id,
          sub_category_name: this.subcate.name3,
          sub_category_desc: this.subcate.description3,
        };
        this.$http
          .post("/api/subcategories/update?where[id]=" + idup, subcate)
          .then(function (response) {
            _this.loading = false;
            _this.warningModal2 = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = "Subcategory Updated Successfully";
            setTimeout(function () {
              _this.errorMessage.message = "";
              _this.hasErrors.message = false;
            }, 4000);
            _this.subcatval();
          })
          .catch(function (error) {
            _this.loading = false;
          });
      }
    },

    submodel() {
      var _this = this;
      var submit_true = 0;
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      var submit_true = 0;
      _this.hasErrors.category2 = "";
      if (this.category.name2 == "") {
        submit_true = 1;
        _this.hasErrors.category2 = "Required";
      }
      if (
        _this.category.name2.length > 100 ||
        _this.category.name2.length < 2
      ) {
        submit_true = 1;
        _this.hasErrors.category2 = "Enter Maximum 100 and Minimum 2 Chracters";
      }
      if (this.category.description3.length > 100) {
        _this.hasErrors.category3 = "Enter Maximum 100 characters";
        submit_true = 1;
      }
      if (this.category.description3 == "") {
        _this.hasErrors.category3 = "Required";
        submit_true = 1;
      }
      if (submit_true == 0) {
        this.loading = true;
        this.hasErrors.category2 = false;
        this.hasErrors.category3 = false;
        var category = {
          category_name: this.category.name2.trim(),
          category_desc: this.category.description3.trim(),
        };
        this.$http
          .post("/api/categories/update?where[id]=" + idup, category)
          .then(function (response) {
            _this.loading = false;
            _this.warningModal = false;
            _this.hasErrors.message1 = true;
            _this.getCategories();
            _this.categorylist();
            _this.errorMessage.message1 = "Category Updated Successfully";
            setTimeout(function () {
              _this.errorMessage.message1 = "";
              _this.hasErrors.message1 = false;
            }, 4000);
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
      }
    },

    getCategories(val) {
      if (val === "comp") {
        if (this.cfrst_time === false) {
          this.cfrst_time = true;
        } else {
          return;
        }
      }
      // console.log("getCategories")
      var _this = this;
      this.loading = true;
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.$http
        .get(
          "/api/categories/showCategories?params=" + JSON.stringify(filteParam)
        )
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          _this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    Submit() {
      var _this = this;
      this.hasErrors.category = "";
      this.hasErrors.category1 = "";
      var submit_true = 0;
      _this.category.name = _this.category.name.trim();
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      if (_this.category.name.length > 100 || _this.category.name.length < 2) {
        submit_true = 1;
        _this.hasErrors.category = "Enter Maximum 100 and Minimum 2 characters";
      }
      if (_this.category.name == "") {
        _this.hasErrors.category = "Required";
        submit_true = 1;
      }
      if (_this.category.description == "") {
        _this.hasErrors.category1 = "Required";
        submit_true = 1;
      }
      if (this.category.description.length > 100) {
        _this.hasErrors.category1 = "Enter Maximum 100 characters allowed";
        submit_true = 1;
      }
      if (submit_true == 0) {
        this.loading = true;
        this.hasErrors.category = false;
        this.hasErrors.category1 = false;
        var category = {
          category_name: this.category.name.trim(),
          category_desc: this.category.description,
        };
        this.$http
          .post("/api/categories", category)
          .then(function (response) {
            _this.loading = false;
            _this.hasErrors.message1 = true;
            _this.errorMessage.message1 = "Category Added Successfully";
            setTimeout(function () {
              _this.errorMessage.message1 = "";
              _this.hasErrors.message1 = false;
            }, 4000);
            _this.largeModal1 = false;
            _this.reset();
            _this.getCategories();
            _this.categorylist();
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error.response);
          });
      }
    },

    Save() {
      var _this = this;
      var submit_true = 0;
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      _this.hasErrors.subcate = "";
      _this.hasErrors.subcate1 = "";

      if (this.Productvalue == null) {
        _this.hasErrors.categoryopt = "Please Select Category";
        submit_true = 1;
      }

      if (_this.subcate.name == "") {
        submit_true = 1;
        _this.hasErrors.subcate = "Required";
      } else {
        if (_this.subcate.name.length > 100 || _this.subcate.name.length < 2) {
          submit_true = 1;
          _this.hasErrors.subcate =
            "Enter Maximum 100 characters and Minimum 2 Characters";
        }
      }

      if (_this.subcate.description == "") {
        submit_true = 1;
        _this.hasErrors.subcate1 = "Required";
      } else {
        if (this.subcate.description.length > 100) {
          _this.hasErrors.subcate1 = "Enter Maximum 100 characters";
          submit_true = 1;
        }
      }

      if (submit_true == 0) {
        this.loading = true;
        var subcate = {
          category_id: this.Productvalue.category_id,
          sub_category_name: this.subcate.name,
          sub_category_desc: this.subcate.description,
        };
        this.$http
          .post("/api/subcategories", subcate)
          .then(function (response) {
            _this.loading = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = "Subcategory Added Successfully";
            setTimeout(function () {
              _this.errorMessage.message = "";
              _this.hasErrors.message = false;
            }, 4000);
            _this.largeModal = false;
            _this.reset();
            _this.subcatval();
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error.response);
          });
      }
    },

    reset() {
      var _this = this;
      _this.category.name = "";
      _this.Productvalue = null;
      _this.category.description = "";
      _this.subcate.name = "";
      _this.subcate.description = "";
    },
  },
};
</script>
<style type="text/css">
  .modal-title{
  color:black;
  font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/Category.vue